export default "__VITE_ASSET__2cf46c71__"